export const PERSONAL_TARGET_ROUTE = '/personal';
export const PERSONAL_MOBILE_ROOT_ROUTE = '/personal/mobile';
export const PERSONAL_MOBILE_HOME_ROUTE = '/personal/mobile/home';
export const BUSINESS_TARGET_ROUTE = '/business';
export const SUPPORT_TARGET_ROUTE = '/support/users';
export const PROFILE_NOT_FOUND_PATH = 'profile-not-found';
export const PROFILE_NOT_FOUND_ROUTE = `/${PROFILE_NOT_FOUND_PATH}`;
